function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, GeoItem, Radius, InputContainer, Label, Input } from './GeoCoordinates.styles';

var GeoCoordinates = function GeoCoordinates(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var coordinates = value.coordinates,
      maxDistanceMiles = value.maxDistanceMiles;

  var _coordinates = _slicedToArray(coordinates, 2),
      lat = _coordinates[0],
      long = _coordinates[1];

  return React.createElement(Container, null, React.createElement(GeoItem, null, React.createElement(InputContainer, null, React.createElement(Label, null, t('query_creator_geo_coordinates.lat_label')), React.createElement(Input, {
    type: "number",
    "data-testid": "lat-input",
    value: lat,
    onChange: function onChange(e) {
      var updatedLat = e.currentTarget.value ? parseInt(e.currentTarget.value) : undefined;

      _onChange(_objectSpread(_objectSpread({}, value), {}, {
        coordinates: [updatedLat, long]
      }));
    }
  }))), React.createElement(GeoItem, null, React.createElement(InputContainer, null, React.createElement(Label, null, t('query_creator_geo_coordinates.long_label')), React.createElement(Input, {
    type: "number",
    "data-testid": "long-input",
    value: long,
    onChange: function onChange(e) {
      var updatedLong = e.currentTarget.value ? parseInt(e.currentTarget.value) : undefined;

      _onChange(_objectSpread(_objectSpread({}, value), {}, {
        coordinates: [lat, updatedLong]
      }));
    }
  }))), React.createElement(GeoItem, null, React.createElement(Radius, null, React.createElement(InputContainer, null, React.createElement(Label, null, t('query_creator_geo_coordinates.radius_label')), React.createElement(Input, {
    type: "number",
    "data-testid": "radius-input",
    value: maxDistanceMiles,
    onChange: function onChange(e) {
      var updatedRadius = e.currentTarget.value ? parseInt(e.currentTarget.value) : undefined;

      _onChange(_objectSpread(_objectSpread({}, value), {}, {
        maxDistanceMiles: updatedRadius
      }));
    }
  }), React.createElement(Label, null, t('query_creator_geo_coordinates.radius_unit'))))));
};

export default GeoCoordinates;